import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { UserService } from 'src/app/core/services/user.service';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { ICase } from 'src/app/modules/cases/interfaces/case.interface';
import { GenerateXlsxCasesResumeService } from 'src/app/modules/cases-archived/services/generate-xlsx-cases-resume.service';
import { ExportToCsv } from 'export-to-csv';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { AuditService } from 'src/app/services/audit.service';
import * as moment from 'moment';
import { async } from 'rxjs/internal/scheduler/async';
enum status {
  initial = 'Sin comenzar',
  running = 'En ejecución',
  tobeApproved = 'Por aprobar',
  toFinalize = 'Por finalizar',
  archived = 'Archivado',
  pending = 'Pendiente',
}

@Component({
  selector: 'app-log-cases',
  templateUrl: './log-cases.component.html',
  styleUrls: ['./log-cases.component.scss'],
})
export class LogCasesComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private userService: UserService,
    private caseService: CasesService,
    private readonly generateXlsxCasesResumeService: GenerateXlsxCasesResumeService
  ) {}
  form1 = false;
  currentUser = this.userService.currentUser;
  form2 = false;
  unit: boolean;
  estatus = status;
  searchTouch: boolean;
  ngOnInit() {
    this.getAllRecords();
    this.caseService.filterRecordCases.subscribe({
      next: (filters: any) => {
        for (let key in filters) {
          if (
            filters[key] == '' ||
            filters[key] == 'null' ||
            filters[key] == null
          ) {
            delete filters[`${key}`];
          }
        }
        if (Object.keys(filters).length === 0) {
          this.getAllRecords();
        } else {
          this.getCaseRecordsFilters(filters);
        }
      },
    });
  }
  async getCaseRecordsFilters(filters) {
    this.isLoading = true;
    await this.caseService
      .getAllRecordCasesFilters(filters)
      .subscribe(async (caseRecords) => {
        let records = await this.transformCaseLogs(caseRecords);

        this.setDataAuditory(records);
      });
  }
  getAuditory(filters) {
    this.caseService.getAllRecordCasesFilters(filters).subscribe((records) => {
      this.setDataAuditory(records);
    });
  }

  async getAllRecords() {
    this.isLoading = true;
    await this.caseService.getAllCaseRecords().subscribe(async (records) => {
      // this.setDataAuditory(records);
      let recordsFormated = await this.transformCaseLogs(records);
      this.setDataAuditory(recordsFormated);
    });
  }
  isLoading = true;
  public transformCaseLogs(caseLogs) {
    return caseLogs.map((log) => {
      // const { action, user, more_info } = log;

      return {
        ...log,
        ip: log.ip,
        user_id: log.userString ? log.userString : 'Usuario no definido',
        role: log.role ? log.role : 'sin rol', //log.user.role.name,
        unit: this.caseUnit(log),
        case_type: this.caseCaseType(log),
        status: this.estatus[log.status],
        gai: this.caseGai(log),
        action: log.action,
        date: log.createdAt, // moment(log.createdAt).format('DD-MM-YYYY HH:mm:ss'),
      };
    });
  }
  count = 0;
  setCount(count) {
    this.count = count;
  }
  caseUnit(log) {
    if (log.unit) {
      return log.unit;
    } else if (log.case && log.case !== null) {
      if (log.case.caseType) {
        return log.case.caseType.unit.name;
      } else {
        return 'Sin Información ';
      }
    } else {
      return 'Sin Información ';
    }
  }
  caseCaseType(log) {
    if (log.case_type) {
      return log.case_type;
    } else if (log.case && log.case !== null) {
      if (log.case.caseType) {
        return log.case.caseType.name;
      } else {
        return 'Sin Información ';
      }
    } else {
      return 'Sin Información del caso';
    }
  }
  caseGai(log) {
    if (log.gai) {
      return log.gai;
    } else if (log.case) {
      return log.case.gai;
    } else {
      return 'Sin Información del caso';
    }
  }

  caseLogs: any[] = [];
  dataSourceCaseLogs;
  setDataAuditory(records: any[]) {
    //this.transformAuditoryLogs(caseLogs);
    this.caseLogs = records;
    this.list = records;
    this.dataSourceCaseLogs = new MatTableDataSource<any>(records);
    this.dataSourceCaseLogs.paginator = this.paginator;
    this.isLoading = false;
  }

  public back() {
    window.history.go(-1);
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('caseLogsPaginator') caseLogsPaginator: MatPaginator;

  dataSource: MatTableDataSource<ICase>;

  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSourceCaseLogs.paginator = this.caseLogsPaginator;
    }, 1000);
  }

  list: ICase[] = [];

  displayedColumnsCaseLogs: string[] = [
    'ip',
    'user_id',
    'role',
    'unit',
    'case_type',
    'status',
    'gai',
    'action',
    'date',
  ];

  see(id) {
    this.router.navigate([`/case/${id}`]);
  }

  downloadResume() {
    this.generateXlsxCasesResumeService.generate();
  }

  filter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceCaseLogs.filter = filterValue.trim().toLowerCase();
  }

  options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'Logs_Casos_CSV',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: 'Logs_Casos_CSV',
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
  };
  exportToCsv() {
    let copyData = this.caseLogs.map((data) => {
      delete data._id;
      delete data.__v;
      if (data.case) {
        data.case = data.case.gai;
      } else {
        data.case = 'sin información';
      }
      if (data.user) {
        data.user = data.user.username;
      } else {
        data.user = 'sin información';
      }
      return data;
    });

    const csvExporter = new ExportToCsv(this.options);

    csvExporter.generateCsv(copyData);
  }
}
